import $ from 'swiper/esm/utils/dom';
import {scrollTo, data} from 'dom7';

$.fn['scrollTo'] = scrollTo;
$.fn['data'] = data;

let common = require('./modules/common');
common.init();

let internals = {
    initSlider: function (Swiper) {
        let slider =new Swiper('#slider', {
            loop: false,
            lazy: {
                loadPrevNext: true,
            },
            slidesPerView: 1.3,
            spaceBetween: 30,
            init: false,
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
        });

        common.observeSlider('slider', slider)
    },
    initForm: function () {
        let form = document.getElementById('page-form');

        if (form === null) {
            return;
        }

        import(/* webpackChunkName: "slimselect" */ 'slim-select').then(function (module) {
            document.querySelectorAll('.select-init').forEach(function (el) {
                new module.default({
                    select: el,
                    showSearch: false,
                    onChange: function (info) {
                        if (info.data.reload) {
                            document.querySelectorAll('.form-block').forEach(function (el) {
                                el.classList.remove('form-block--active');
                            });
                            document.querySelector('.form-block[data-id="' + info.value + '"]').classList.add('form-block--active');
                        }
                    }
                })
            });
        });

        import(/* webpackChunkName: "validation" */'./modules/validation').then(function (validation) {
            let plugins = {
                declarative: new validation.DeclarativePlugin(),
                submitButton: new validation.SubmitButtonPlugin(),
                bootstrap: new validation.BootstrapPlugin({
                    rowSelector: '.order-form__group'
                }),
                trigger: new validation.TriggerPlugin()
            };

            if (form.getAttribute('data-fvp-recaptcha___element')) {
                plugins.recaptcha = new validation.RecaptchaPlugin({
                    element: form.getAttribute('data-fvp-recaptcha___element'),
                    language: form.getAttribute('data-fvp-recaptcha___language'),
                    message: form.getAttribute('data-fvp-recaptcha___message'),
                    siteKey: form.getAttribute('data-fvp-recaptcha___site-key'),
                    theme: form.getAttribute('data-fvp-recaptcha___theme'),
                    size: form.getAttribute('data-fvp-recaptcha___size'),
                    badge: form.getAttribute('data-fvp-recaptcha___badge')
                });
            }

            let fv = validation.fv(form, {plugins: plugins}).on('core.form.valid', function () {
                common.submitForm(fv.getFormElement()).then(function (response) {

                    let goal = $(form).data('goal');
                    if (goal) {
                        let tracking = require('./modules/tracking');
                        tracking.reachGoal(goal);
                    }

                    form.innerHTML = response.message;
                });
            });
            validation.initIntlTelInput();

        });
    },
    initVideo: function () {
        if (!document.getElementById('ytplayer_1')) return;

        internals.observeCallback('ytplayer_1', function () {
            window['onYouTubePlayerAPIReady'] = function () {
                document.querySelectorAll('.video-player').forEach(
                    function (el) {
                        new YT.Player(el.id, {
                            height: '390',
                            width: '640',
                            playerVars: {
                                autoplay: 0,
                                rel: 0
                            },
                            videoId: el.getAttribute('data-code'),
                            origin: 'https://raisa.blog'
                        });
                    }
                );
            };

            let s = document.createElement('script');
            s.src = 'https://www.youtube.com/player_api';
            s.async = true;
            s.defer = true;
            document.body.appendChild(s);
        });
    },
    observeCallback: function (element, callback) {
        if (!('IntersectionObserver' in window)) {
            callback();
        } else {
            let observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        callback();
                        observer.disconnect();
                    }
                });
            }, {
                rootMargin: '10px 0px',
                threshold: 0.01
            });
            observer.observe(document.getElementById(element));
        }
    }
};

if (document.getElementById('slider')) {
    import(
        /* webpackChunkName: "swiper" */
        './modules/swiper').then(function (module) {
        internals.initSlider(module.default);
    }, function (e) {
        console.log('Unable to load swiper library: ' + e.message);
        throw new Error('Unable to load swiper library: ' + e.message);
    });
}

internals.initForm();
internals.initVideo();
